module.exports = __webpack_public_path__ + "static/media/SM-ST2-TRIAL-if-wrong.fa41c9f6.mp3";